import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { NetworkContext } from '../context/NetworkContext';
import { SYNC_STATUS } from '../context/types/NetworkTypes';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft, ArrowLeft, RefreshCw } from 'lucide-react';
import { RootState, checkBackTargetPage } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import CustomText from '../styles/CustomText';

const Header: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { 
		syncStatus, 
		countSyncProcess, 
		countSyncComplete,
		syncAllTransaction
	} = useContext(NetworkContext)

	let navigate = useNavigate();
	let dispatch = useDispatch();
	let location = useLocation();
	const { t } = useTranslation();
	const [ refreshing, setRefreshing ] = useState(false)

	let headerText = useSelector((state: RootState) => state.headerText);
	const backTargetPage = useSelector((state: RootState) => state.backTargetPage.value);

	useEffect(() => {
		const syncLoading = async () => {
			if(syncStatus === SYNC_STATUS.CHECKING ||syncStatus === SYNC_STATUS.PROCESSING) {
				setRefreshing(true)
			} else {
				setRefreshing(false)
			}
		}

		syncLoading()

	}, [syncStatus])

	const handleBackButton = async () => {
		try {
			if(null != backTargetPage && '' !== backTargetPage) {
				// backtarget 페이지가 있을 경우
				console.log(`backtarget 설정값 있음`)
				dispatch(checkBackTargetPage('')) // Header 백버튼 이동 페이지 설정
				navigate(backTargetPage, { replace: true, state: {} });
			} else {
				// backtarget 페이지가 없을 경우
				console.log(`backtarget 설정값 없음`)
				navigate(-1)
			}
			
		} catch (e) {
			console.error(e);
		}
	}

	const styles = {
		container: {
			width: "calc(100% - 48px)",
			height: "30px",
			padding: "12px 24px",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			top: "0",
			left: "0",
			background: theme.background_03,
			position: "fixed",
			zIndex: 100
		} as React.CSSProperties,
		icon: {
			position: "absolute",
			left: "13px",
			top: "50%",
			transform: "translateY(-50%)",
			width: "27px",
			height: "27px",
			cursor: 'pointer'
		} as React.CSSProperties,
		syncIconBox: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			gap: 20,
		} as React.CSSProperties,
		syncIcon: {
			width: "22px",
			height: "22px",
			cursor: "pointer",
		} as React.CSSProperties,
		syncInfo: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			justifyContent: "center",
			gap: "4px",
			color: theme.text_02,
			fontSize: "12px",
		} as React.CSSProperties,
		syncText: {
			color: theme.text_01,
			fontSize: "18px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		} as React.CSSProperties,
		text: {
			color: theme.text_01,
			fontSize: "16px",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			// paddingBottom: "3px"
		} as React.CSSProperties,
	}

	return (
		<div style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={{ ...styles.icon }} onClick={() => navigate(-1)}>
				{/* <ChevronLeft size={27} color={theme.text_01} /> */}
				<ArrowLeft size={27} color={theme.text_01} />
			</div>
			<div style={{ color: "white", display: "flex", alignItems: "center", gap: "0px" }}>
				{syncStatus === SYNC_STATUS.COMPLETE && (
					<div>
						<CustomText style={{ ...styles.text }}>{headerText?.title ?? ""}</CustomText>
					</div>
				)}
				<div style={{ ...styles.syncIconBox }}>
					<div style={styles.syncInfo}>
						{/* <div style={styles.walletName}>{walletName}</div>
						<div style={styles.walletAddress}>{walletAddress}</div> */}
						{syncStatus === SYNC_STATUS.CHECKING && (
							// <CustomText style={{ ...styles.syncText }}>
							// 	{t('sync_db_tx_message_02')}
							// </CustomText>
							<></>
						)}
						{syncStatus === SYNC_STATUS.PROCESSING && (
							<CustomText style={{ ...styles.syncText }}>
								{countSyncProcess}/{countSyncComplete}
							</CustomText>
						)}
						{syncStatus === SYNC_STATUS.STOP && (
							<CustomText style={{ ...styles.syncText }}>
								{t('sync_db_tx_message_03')}
							</CustomText>
						)}
						{syncStatus === SYNC_STATUS.COMPLETE && (
							<></>
						)}
						{syncStatus === SYNC_STATUS.ERROR && (
							<CustomText style={{ ...styles.syncText }}>
								{t('sync_db_tx_message_05')}
							</CustomText>
						)}
						{syncStatus === SYNC_STATUS.SYNCKEY_ERROR && (
							<CustomText style={{ ...styles.syncText }}>
								{t('sync_db_tx_message_06')}
							</CustomText>
						)}
					</div>
					{(syncStatus === SYNC_STATUS.PROCESSING) && (
						<div style={{ ...styles.syncIcon }} onClick={() => {}}>
							<RefreshCw
								color={theme.text_01}
								size={22}
								className={refreshing ? 'rotating-icon-repeat' : ''}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default Header
